import React from 'react'

const Balance = () => {
  return (
    <div className='flex flex-col gap-2'>
        <h4 className="text-[#6922D1] text-sm font-[400]">Available Balance</h4>
        <p className="text-[#333333] text-[37px] font-[600]">₦2,300,000,000</p>
    </div>
  )
}

export default Balance;
